"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Table, _Component);

  function Table(props) {
    (0, _classCallCheck3.default)(this, Table);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call(this, props));

    _this.state = {
      combineTemp: ""
    };
    _this.getHeader = _this.getHeader.bind(_this);
    _this.getRowsData = _this.getRowsData.bind(_this);
    _this.getKeys = _this.getKeys.bind(_this);
    _this.temp = "";
    return _this;
  }

  (0, _createClass3.default)(Table, [{
    key: "getKeys",
    value: function getKeys() {
      if (this.props.settings) {
        if (this.props.settings.headers) {
          return (0, _keys2.default)(this.props.settings.headers);
        } else {
          return null;
        }
      }
    }
  }, {
    key: "getHeader",
    value: function getHeader() {
      if (this.props.settings) {
        if (this.props.settings.headers) {
          var headers = this.props.settings.headers;
          return (0, _keys2.default)(headers).map(function (key, index) {
            return _react2.default.createElement(
              "th",
              null,
              headers[key]
            );
          });
        } else {
          return null;
        }
      }
    }
  }, {
    key: "getRowsData",
    value: function getRowsData() {
      var _this2 = this;

      var items = this.props.data;

      return items.map(function (row, index) {
        return _react2.default.createElement(
          "tr",
          { key: index },
          _this2.renderRow(row)
        );
      });
    }
  }, {
    key: "checkFormat",
    value: function checkFormat(index) {
      if (this.props.settings) {
        if (this.props.settings.format) {
          var format = this.props.settings.format;
          var cellType = format.filter(function (type) {
            return type.cell == index;
          });
          if ((0, _keys2.default)(cellType).length > 0) {
            return cellType[0].type;
          }
        }
      }
      return null;
    }
  }, {
    key: "checkCombineCells",
    value: function checkCombineCells(index) {
      if (this.props.settings) {
        if (this.props.settings.combineCells) {
          var combineCells = this.props.settings.combineCells;
          var cellType = combineCells.filter(function (type) {
            return type.cell == index;
          });
          if ((0, _keys2.default)(cellType).length > 0) {
            return cellType[0].type;
          }
        }
      }
      return null;
    }
  }, {
    key: "renderCell",
    value: function renderCell(data, index) {
      var _this3 = this;

      var format = this.checkFormat(index);
      var newData = data;
      if (format) {

        if (format === "dateTime") {
          newData = (0, _moment2.default)(data).format("D.M.YYYY HH.mm");
        }

        if (format === "date") {
          newData = (0, _moment2.default)(data).format("D.M.YYYY");
        }

        if (format === "hidden") {
          return null;
        }

        if (format === "booleanImage") {
          var str = null;
          if (data == false) {
            str = _react2.default.createElement(
              "span",
              { style: { color: "red" } },
              "!!"
            );
          }
          newData = str;
        }
        if (format === "button") {
          var _str = null;
          /*          str = <Button
                      key={index}
                      item={data}
                      text="Lisää"
                      onClick={this.handleButtonClick.bind(this,index)}
                    /> */
          _str = _react2.default.createElement(
            "button",
            { onClick: function onClick() {
                return _this3.props.buttonOnClick(data);
              } },
            "Lis\xE4\xE4"
          );

          newData = _str;
        }
      }
      var combine = this.checkCombineCells(index);
      if (combine) {
        if (combine === "right") {
          this.temp = newData;
          return null;
        } else {
          this.temp = "";
        }
      }
      if (this.temp.length > 0) {
        newData = _react2.default.createElement(
          "span",
          null,
          this.temp,
          "  ",
          newData,
          " "
        );
        this.temp = "";
      }

      return _react2.default.createElement(
        "td",
        null,
        newData
      );
    }
  }, {
    key: "renderRow",
    value: function renderRow(row) {
      var _this4 = this;

      var addButton = false;
      var newRow = row;
      if (addButton) {
        newRow.buttonData = row;
      }
      if (this.props.data) {
        console.info("row", newRow);
        return (0, _keys2.default)(newRow).map(function (key, index) {
          return _this4.renderCell(newRow[key], index);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(
          "table",
          { className: "table user-vouchers-table" },
          _react2.default.createElement(
            "thead",
            null,
            _react2.default.createElement(
              "tr",
              null,
              this.getHeader()
            )
          ),
          _react2.default.createElement(
            "tbody",
            null,
            this.getRowsData()
          )
        )
      );
    }
  }]);
  return Table;
}(_react.Component), _class.propTypes = {
  buttonOnClick: _react.PropTypes.func
}, _temp);
exports.default = Table;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/table/Table.js
 ** module id = 1187
 ** module chunks = 0
 **/